export default "__VITE_ASSET__a30e4a78__"